const vendor = {
  modal: {
    editVendor: 'Editar entrada',
    exportVendor: 'Exportar',
    storeVendor: 'Añadir nueva entrada',
    share: 'Compartir',
    store: 'Tienda',
    vendor: 'Proveedor',
    country: 'País',
    mature: 'Maduro',
    products: 'Productos',
    successUpdate: 'Entrada existente actualizada correctamente',
    successStore: 'Nueva entrada añadida correctamente',
    exportVendorsLoading: 'Cargando proveedores exportados...',
  },
  page: {
    adminVendors: 'Administrador de proveedores',
    adminVendorsOptions: 'Opciones del administrador de proveedores',
    showing: 'mostrando',
    vendorsOf: 'Proveedores de',
    noVendorsFound: "No hay proveedores' Encontrado",
  },
  tableDropdown: {
    quickActions: 'Acciones rápidas',
    refresh: 'Actualizar',
    exportVendors: 'Exportar',
    prepareExportVendors: 'Preparar exportación',
  },
  actionsDropdown: {
    edit: 'Editar',
    delete: 'Eliminar',
  },
  messages: {
    vendorDeleted: 'Proveedor eliminado correctamente',
    vendorUpdated: 'Proveedor actualizado correctamente',
  }
};

export default vendor;
